import React, { useState, useRef } from "react";
import { Popper, Paper, Fade, Box } from "@mui/material";

export const OverlayTooltip = ({ title, children, containerSx, ...props }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    return (
        <>
            <Box
                ref={anchorRef}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                sx={{ display: "inline-flex", ...containerSx }}
            >
                {children}
            </Box>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement={props.placement || "top"}
                transition
                sx={{
                    zIndex: 999999,   // über jedem Overlay
                    pointerEvents: "none"
                }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={120}>
                        <Paper
                            sx={{
                                px: 1.2,
                                py: 0.6,
                                fontSize: "0.75rem",
                                borderRadius: 1,
                                boxShadow: 3,
                            }}
                        >
                            {title}
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </>
    );
}
